import React from "react";

import {useWeather} from "../contextprovider/weather";



const Input = ()=>{
    const myweather = useWeather();
    return (
        <div>
            <input
               className="input-field"
               type="text"
                placeholder="Enter City Here"
                value={myweather.input || ""} 
                onChange={(e) => myweather.setInput(e.target.value)}
/>

        </div>
    );
}


export default Input;